import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
    SharedAllocationExecution,
    SharedAllocationExecutionCancelAllocationExecutionAction,
    SharedAllocationExecutionCode,
    SharedAllocationExecutionExecuteAllocationAction,
    SharedAllocationExecutionSetParamsAction
} from 'src/app/_shared/stores/shared-allocation-execution/shared-allocation-execution.actions';
import {
    MutationAnnulerExecutionAttributionBdgArgs,
    MutationExecuterOrUpdateAttDbgBenefArgs
} from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { GraphqlService } from 'src/app/_core/services/graphql.service';

export class SharedAllocationExecutionStateModel {

    code: SharedAllocationExecutionCode = null;

    allocation: SharedAllocationExecution;

}

@Injectable()
@State<SharedAllocationExecutionStateModel>({
    name: 'sharedAllocationExecution',
    defaults: new SharedAllocationExecutionStateModel()
})
export class SharedAllocationExecutionState {

    constructor(private readonly graphqlService: GraphqlService) {
    }

    @Selector()
    static allocation(state: SharedAllocationExecutionStateModel): SharedAllocationExecution {
        return state.allocation;
    }

    @Selector()
    static code(state: SharedAllocationExecutionStateModel): SharedAllocationExecutionCode {
        return state.code;
    }

    @Action(SharedAllocationExecutionExecuteAllocationAction)
    executeAllocation(state: StateContext<SharedAllocationExecutionStateModel>, {payload}: SharedAllocationExecutionExecuteAllocationAction) {
        return this.graphqlService.mutateOne<'ExecuterOrUpdateAttDBGBenef', MutationExecuterOrUpdateAttDbgBenefArgs>({
            mutation: gql`
                mutation ExecuterOrUpdateAttDBGBenef(
                    $contexte: ContextInfosInput,
                    $modeleExecAtr: ModeleExecAttributionBudgetDTOInput
                ) {
                    ExecuterOrUpdateAttDBGBenef(
                        contexte: $contexte
                        modeleExecAtr: $modeleExecAtr
                    )
                }
            `,
            variables: {
                modeleExecAtr: payload
            }
        });
    }

    @Action(SharedAllocationExecutionCancelAllocationExecutionAction)
    cancelAllocationExecution(state: StateContext<SharedAllocationExecutionStateModel>, {payload}: SharedAllocationExecutionCancelAllocationExecutionAction) {
        return this.graphqlService.mutateOne<'AnnulerExecutionAttributionBDG', MutationAnnulerExecutionAttributionBdgArgs>({
            mutation: gql`
                mutation AnnulerExecutionAttributionBDG(
                    $contexte: ContextInfosInput,
                    $idAttbdg: Float,
                    $ContextAttBDG: String
                ) {
                    AnnulerExecutionAttributionBDG(
                        contexte: $contexte
                        idAttbdg: $idAttbdg
                        ContextAttBDG: $ContextAttBDG
                    )
                }
            `,
            variables: {
                idAttbdg: payload.allocationId,
                ContextAttBDG: payload.code
            }
        });
    }

    @Action(SharedAllocationExecutionSetParamsAction)
    setParams({patchState}: StateContext<SharedAllocationExecutionStateModel>, {payload}: SharedAllocationExecutionSetParamsAction) {
        patchState({
            code: payload.code,
            allocation: payload.allocation
        });
    }

}
